<template>
    <div>
        <vue-headful :title="'[Admin] Billing - AMOS365'" />

        <h4 class="font-weight-bold py-3 mb-4">
            <span class="text-muted font-weight-light">Admin /</span> Billing
        </h4>

        <div class="row">
            <div class="col-lg-8">
                <div class="card mb-3">
                    <div class="card-header">
                        <strong>Billing Settings</strong>
                    </div>
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-danger': errors.max_users, 'text-muted': !errors.max_users}">
                                User Licenses:
                            </div>
                            <div class="col-lg-6 col-12">
                                <input type="text" v-model="account.max_users" :class="{'form-control': true, 'is-invalid': errors.max_users}" placeholder="Enter Desired Number of User Licenses" />

                                <div class="text-danger mt-1" v-if="errors.max_users">
                                    <ul class="list-unstyled mb-0">
                                        <li v-for="err in errors.max_users">{{ err }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <button type="button" class="btn btn-sm btn-success" v-on:click="postBilling()">
                    Update Billing
                </button>
            </div>
            <div class="col-lg-4 mt-lg-0 mt-3">
                    <div class="card mb-3">
                        <div class="card-header">
                            <strong>Active Users</strong>
                        </div>
                        <div class="card-body">
                            <h1>{{ activeUsers }} / {{ account.max_users }}</h1>

                            <span class="text-muted">${{ cost_per_user }} / User, Total: ${{ cost_per_user * account.max_users }}</span>
                        </div>
                    </div>

                    <div class="card mb-3">
                        <div class="card-header">
                            <strong>User Logins MTD</strong>
                        </div>
                        <div class="card-body">
                            <h1 v-if="userData.length > 0">{{ userData[userData.length - 1].user_logins }}</h1>
                            <h1 v-else>0</h1>

                            <span class="text-muted">Count of Unique User Logins This Month</span>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-header">
                            <strong>Report Emails Sent MTD <i class="fa fa-question-circle" title="This Statistic only counts emails sent to non-Users"></i></strong>
                        </div>
                        <div class="card-body">
                            <h1 v-if="emailData.length > 0">{{ emailData[emailData.length - 1].emails_sent }}</h1>
                            <h1 v-else>0</h1>

                            <span class="text-muted">${{ cost_per_1000_emails }} / 1,000 emails, Total: $<span v-if="emailData.length > 0">{{ cost_per_1000_emails * Math.ceil(emailData[emailData.length - 1].emails_sent / 1000) }}</span></span>
                        </div>
                    </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        data() {
            return {
                loading: true,
                saving: false,
                errors: {},
                activeUsers: null,
                cost_per_user: null,
                cost_per_1000_emails: null,
                userData: [],
                emailData: [],
                account: {},
            }
        },

        watch: {

        },

        computed: {

        },

        methods: {
            getBilling(){
                //Send it
                this.$http.get('/admin/billing')
                    .then(response => {
                        //Set Data
                        this.cost_per_user = response.data.cost_per_user;
                        this.cost_per_1000_emails = response.data.cost_per_1000_emails;
                        this.activeUsers = response.data.activeUsers;
                        this.userData = response.data.userData;
                        this.emailData = response.data.emailData;
                        this.account = response.data.account;
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            postBilling(){
                //Reset
                this.saving = true;
                this.errors = {};

                //Send it
                this.$http.post('/admin/billing', this.account)
                    .then(response => {
                        //Alert the user
                        this.$toastr.s('Billing Updated');
                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data.errors;

                            //Alert
                            this.$toastr.e('Validation Errors Occurred');
                        }
                        else
                        {
                            //Alert the user
                            this.$toastr.e(error.response.data, 'Failed to Update Billing');
                        }
                    })
                    .then(() => {
                        //Reset
                        this.saving = false;
                    });
            },
        },

        mounted() {
            //Get the Data
            this.getBilling();
        }
    }
</script>